import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import './Footer.css'

const Footer = () => {

  const [showPopup, setShowPopup] = useState(false);

  const togglePopup = () => {
    setShowPopup(!showPopup);
  };

  return (
    <div className='footer-container'>
      <div className='footer-section-1'>
        <div className='footer-child-logo'>
          <img src='/images/risesvg.svg' alt='error' className='download-img' />
          <p className='brand-para'>RISEFX is a leading financial trading platform offering a wide range of trading solutions, empowering traders worldwide to explore the markets with confidence.</p>
        </div>


        <div className='footer-child-1'>
          <ul className='footer-ul'>
            <h3 className='ul-heading'>About Us</h3>
            <Link to='/about' onClick={() => window.scrollTo(0, 300, { behavior: 'smooth' })}>
              <li className='footer-list'>About RiseFX</li></Link>
            <Link
              to="/about"
              onClick={() => {
                sessionStorage.setItem("activeSection", "mission"); // Store section
                window.scrollTo({ top: 300, behavior: "smooth" }); // Smooth scroll
              }}
            >
              <li className="footer-list">Our Mission</li>
            </Link>

            <Link to='/about'
              onClick={() => {
                sessionStorage.setItem("activeSection", "services"); // Store section
                window.scrollTo({ top: 300, behavior: "smooth" }); // Smooth scroll
              }}
            >
              <li className='footer-list'>Our Service</li>
            </Link>
            <Link to='/about'
              onClick={() => {
                sessionStorage.setItem("activeSection", "why"); // Store section
                window.scrollTo({ top: 300, behavior: "smooth" }); // Smooth scroll
              }}
            >
              <li className='footer-list'>Why RiseFX</li></Link>

          </ul>
        </div>



        <div className='footer-child-2'>
          <ul className='footer-ul'>
            <h3 className='ul-heading'>Trading</h3>
            <Link to='/trading'
              onClick={() => {
                sessionStorage.setItem("activeSection", "forex"); // Store section
                window.scrollTo({ top: 1100, behavior: "smooth" }); // Smooth scroll
              }}>
              <li className='footer-list'>Forex Trade</li>
            </Link>

            <Link to='/trading'
              onClick={() => {
                sessionStorage.setItem("activeSection", "metal"); // Store section
                window.scrollTo({ top: 1100, behavior: "smooth" }); // Smooth scroll
              }}>
              <li className='footer-list'>Metal Trade</li>
            </Link>

            <Link to='/trading'
              onClick={() => {
                sessionStorage.setItem("activeSection", "indices"); // Store section
                window.scrollTo({ top: 1100, behavior: "smooth" }); // Smooth scroll
              }}>
              <li className='footer-list'>Indices Trade</li>
            </Link>

            <Link to='/trading'
              onClick={() => {
                sessionStorage.setItem("activeSection", "commodities"); // Store section
                window.scrollTo({ top: 1100, behavior: "smooth" }); // Smooth scroll
              }}>
              <li className='footer-list'>Commodities Trade</li>
            </Link>
          </ul>
        </div>



        <div className='footer-child-3'>
          <ul className='footer-ul'>
            <h3 className='ul-heading'>Platform & Tools</h3>
            <Link to='/platform'
              onClick={() => {
                sessionStorage.setItem("activeSection", "risefxMobileApp"); // Store section
                window.scrollTo({ top: 300, behavior: "smooth" }); // Smooth scroll
              }}>
              <li className='footer-list'>RiseFX Mobile App</li>
            </Link>

            <Link to='/platform'
              onClick={() => {
                sessionStorage.setItem("activeSection", "risefxWebTrade"); // Store section
                window.scrollTo({ top: 300, behavior: "smooth" }); // Smooth scroll
              }}>
              <li className='footer-list'>RiseFX Web Trade</li>
            </Link>

            <Link to='/platform'
              onClick={() => {
                sessionStorage.setItem("activeSection", "risefxPlatform"); // Store section
                window.scrollTo({ top: 300, behavior: "smooth" }); // Smooth scroll
              }}>
              <li className='footer-list'>RiseFX Platform</li>
            </Link>
          </ul>
        </div>


        <div className='footer-child-3'>
          <ul className='footer-ul'>
            <h3 className='ul-heading'>Partner With Us</h3>
            <Link to='/partner'
              onClick={() => {
                sessionStorage.setItem("activeSection", "overview"); // Store section
                window.scrollTo({ top: 300, behavior: "smooth" }); // Smooth scroll
              }}>
              <li className='footer-list'>Partner Overview</li>
            </Link>

            <Link to='/partner'
              onClick={() => {
                sessionStorage.setItem("activeSection", "whychoose"); // Store section
                window.scrollTo({ top: 300, behavior: "smooth" }); // Smooth scroll
              }}>
              <li className='footer-list'>Why RiseFX</li>
            </Link>

            <Link to='/partner'
              onClick={() => {
                sessionStorage.setItem("activeSection", "benefit"); // Store section
                window.scrollTo({ top: 300, behavior: "smooth" }); // Smooth scroll
              }}>
              <li className='footer-list'>Partnership Benefits</li>
            </Link>
          </ul>
        </div>


        <div className='footer-child-4'>
          <ul className='footer-ul'>
            <h3 className='ul-heading'>Support</h3>
            <Link to='/contact' onClick={() => window.scrollTo(0, 700, { behavior: 'smooth' })}>
              <li className='footer-list'>Contact</li>
            </Link>
            <Link to='/privacy' onClick={() => window.scrollTo(0, 0, { behavior: 'smooth' })}>
              <li className='footer-list'>Privacy Policy</li>
            </Link>
            <Link to='/terms' onClick={() => window.scrollTo(0, 0, { behavior: 'smooth' })}>
              <li className='footer-list'>Terms & Conditions</li>
            </Link>
            <Link to='/refund' onClick={() => window.scrollTo(0, 0, { behavior: 'smooth' })}>
              <li className='footer-list'>Refund Policy</li>
            </Link>
          </ul>
        </div>
        {/* <div className='footer-child-5'>
          <div className='inner-child5 inner-1'>
            <img src='/images/risesvg.svg' alt='error' className='download-img' />
            <p>Download on the App Store</p>
          </div>
          <div className='inner-child5 inner-2'>
            <img src='/images/icon-3.png' alt='error' className='download-img' onClick={togglePopup}/>
          </div>
          <div className='inner-child5 inner-3'>
            <a href='https://panel.therisefx.com/platform/TheRiseFX-1.0.apk'>
              <img src='/images/android-icon.png' alt='error' className='download-img' />
            </a>
            <a href='https://apps.apple.com/us/app/mobiustrader-7/id1355359598'>
              <img src='/images/ios-icon.png' alt='error' className='download-img' />
            </a>
            <a href=''>
              <img src='/images/microsoft-icon.jpg' alt='error' className='download-img microsoft' />
            </a>
          </div>
        </div> */}
      </div>

      <div className='footer-section-3'>
        <div className='footer-child-1'>
          <p className='footer-para'>RISEFX is incorporated in Mauritius with registration number - C191579
            and also registered in Saint Lucia with registration number - 00506. Our website includes links
            and redirection sections to enhance the quality of our services. As a company, we do not endorse
            or recommend any specific products or services. The information provided on this site is intended
            for informational purposes only. Therefore, any offer or solicitation should not be construed
            as an invitation or request to engage in any activity in jurisdictions where such actions are
            not authorized. Additionally, it should not be construed as a recommendation to buy, sell,
            or otherwise engage in any specific currency or precious metal transactions where such
            actions are unlawful.</p>

          <p className='footer-para'>RISK DISCLAIMER: Trading financial products on margin involves a significant
            level of risk and may not be suitable for all investors. It's important to note that losses can
            exceed the initial investment. Therefore, it's crucial to fully comprehend the risks involved and
            take appropriate measures to manage them effectively. Investing in derivatives carries the
            possibility of losing an amount that exceeds the initial investment. It's imperative for investors
            to understand these risks thoroughly before engaging in any trading activities.Anyone wishing to
            invest in any of the products mentioned in https://therisefx.com/ should seek their own financial
            or professional advice. Trading of securities, forex, metals, commodities may not be suitable for
            everyone and involves the risk of losing part or all of your money. Trading in the financial markets
            has large potential rewards, but also large potential risk. You must be aware of the risks and be
            willing to accept them in order to invest in the markets. Don't invest and trade with money which
            you can't afford to lose. Forex Trading is not allowed in some countries, before investing your
            money, make sure whether your country is allowing this or not.</p>

          <p className='footer-para'>Restricted Regions: RISEFX does not provide services for citizens/residents
            of the United States, Cuba, Iraq, Myanmar, North Korea, Sudan. The services of RISEFX are not intended
            for distribution to, or use by, any person in any country or jurisdiction where such distribution
            or use would be contrary to local law or regulation.</p>
        </div>
        {/* <div className='footer-child-2'>2</div> */}
      </div>
      <div className='footer-section-4'>
        <div className='footer-child-1'>
          <p className='copyrights'>
            Copyright © 2007-2025 <span className='footer-brand'>RiseFX</span>. All rights reserved.
          </p>
        </div>
        <div className='footer-section-2'>

          <div className='footer-child-payment'>
            <img src='/images/card-1.png' alt='error' />
            <img src='/images/card-2.png' alt='error' />
            <img src='/images/card-3.png' alt='error' />
            <img src='/images/card-4.png' alt='error' />
            <img src='/images/card-5.png' alt='error' />
            <img src='/images/card-6.png' alt='error' />
          </div>
        </div>
        <div className='footer-child-2'>
          <p className='social-media'>Stay Connected: </p>
          <div className='social-imgs'>
            <a href='https://www.instagram.com/risefx_official/profilecard/?igsh=M2wwNWtnMnZybXRm'>
              <img src='/images/social-1.svg' alt='error' />
            </a>
          </div>
          <div className='social-imgs'>
            <a href='https://www.facebook.com/therisefxofficial'>
              <img src='/images/facebook-icon.svg' alt='error' />
            </a>
          </div>
          <div className='social-imgs'>
            <a href='https://x.com/official_Risefx'>
              <img src='/images/twitter-icon.svg' alt='error' />
            </a>
          </div>
          <div className='social-imgs'>
            <a href='https://www.linkedin.com/company/risefx/'>
              <img src='/images/linkedin.svg' alt='error' />
            </a>
          </div>
        </div>
      </div>
      {showPopup && (
        <div className='popup'>
          <button className='close-btn' onClick={togglePopup}>X</button>
          <div className='popup-content'>
            <img src='/images/QRcode1.png' alt='QR Code 1' className='qr-img' />
            <a href='https://panel.therisefx.com/platform/TheRiseFX-1.0.apk'>
              <img src='images/android-download.png' className='download-icon' alt='error' />
            </a>
          </div>
          <div className='popup-content'>
            <img src='/images/QRcode2.png' alt='QR Code 2' className='qr-img' />
            <a href='https://apps.apple.com/us/app/mobiustrader-7/id1355359598'>
              <img src='images/ios-download.png' className='download-icon' alt='error' />
            </a>
          </div>
        </div>
      )}
    </div>
  );
}

export default Footer;
